const {
	totalGetter, countGetter, avgGetter, ccuGetter,
	formatter, minutesFormatter, sessionLengthFormatter,
	sparkLine, getRow, isStale, SelfReloadingController,
	dashboardMergeCustomiser
} = require("./shared");

const tables = require('../../components/tables');


const METRICS_BLOCK_TEMPLATE = require('../../templates/metrics-block.html');
const FILTERED_METRICS_BLOCK_COLUMNS = [
	{key: 'title', title: 'Metric', sort: false},
	{
		title: '', sort: false,
		call: function (td) {
			td.each(sparkLine);
		}
	},
	{key: 'h1', title: 'Hour'},
	{key: 'h24', title: '24 hours'},
	{key: 'day7', title: '7 days'},
	{key: 'day30', title: '30 days'},
	{key: 'year', title: 'Year'},
	{key: 'life', title: 'Lifetime'}
];

class BasicMetricsBlock extends SelfReloadingController {
	constructor(options) {
		super({
			template: METRICS_BLOCK_TEMPLATE, title: '&npsp;',
			mergeCustomiser: dashboardMergeCustomiser
		}, options);
	}

	get columns() {
		return FILTERED_METRICS_BLOCK_COLUMNS;
	}

	get table() {
		return this._table;
	}

	drawTable(container, options) {
		options = Object.assign({}, this.options, options);
		let table = this._table = new tables.SimpleTable(container, Object.assign({
			columns: this.columns,
			css: 'cm-metrics-table cm-table table table-stripped',
			formatNumber: '0,0[.]00',
		}, _.pick(options, 'formatDate', 'formatNumber')));
		table.draw(options.data.rows);
	}

	processResponse(response) {
		let data = response.data;
		// Check if any of the tabs are stale
		let rows = [];
		rows.push(getRow(data, 'Minutes used', totalGetter, minutesFormatter));
		rows.push(getRow(data, 'Active streams', countGetter, formatter));
		rows.push(getRow(data, 'Average Session Length (minutes)', avgGetter, sessionLengthFormatter));
		rows.push(getRow(data, 'CCU', ccuGetter, formatter));
		return {stale: isStale(data), rows};
	}

	render(options) {
		let self = this;
		return super.render(options)
			.then(function (options) {
				let container = self.container.querySelector('table');
				container.id = _.uniqueId();
				self.drawTable(container, options);
				return options;
			});
	}

	update(options) {
		this.table.redraw(options.data.rows);
		return Promise.resolve(options);
	}
}

module.exports = BasicMetricsBlock;